import React from "react";
import MediaTranslationContext from "app/app/mediaSelector/contexts/MediaTranslationContext";

export default function useMediaTranslation() {
    return React.useContext(MediaTranslationContext);
}
